const chunkMapping = {
	"784": [
		784
	],
	"1044": [
		71044
	],
	"1428": [
		21428
	],
	"1541": [
		31541
	],
	"1583": [
		91583
	],
	"2004": [
		52004
	],
	"2074": [
		52074
	],
	"2716": [
		22716
	],
	"4620": [
		34620
	],
	"5573": [
		15573
	],
	"6390": [
		96390
	],
	"6633": [
		36633
	],
	"7575": [
		7575
	],
	"7633": [
		77633
	],
	"7904": [
		97904
	],
	"7955": [
		57955
	],
	"8064": [
		68064
	],
	"8831": [
		58831
	],
	"9677": [
		39677
	],
	"9799": [
		69799
	]
};
const idToExternalAndNameMapping = {
	"784": [
		"default",
		"./app",
		19942
	],
	"7575": [
		"default",
		"./app",
		642
	],
	"15573": [
		"default",
		"./app",
		2112
	],
	"21428": [
		"default",
		"./powerBiApp",
		71172
	],
	"22716": [
		"default",
		"./app",
		62624
	],
	"31541": [
		"default",
		"./app",
		91224
	],
	"34620": [
		"default",
		"./app",
		40808
	],
	"36633": [
		"default",
		"./app",
		13218
	],
	"39677": [
		"default",
		"./app",
		66732
	],
	"52004": [
		"default",
		"./app",
		47996
	],
	"52074": [
		"default",
		"./app",
		52022
	],
	"57955": [
		"default",
		"./app",
		52916
	],
	"58831": [
		"default",
		"./app",
		48266
	],
	"68064": [
		"default",
		"./app",
		89326
	],
	"69799": [
		"default",
		"./app",
		34308
	],
	"71044": [
		"default",
		"./app",
		78836
	],
	"77633": [
		"default",
		"./app",
		21896
	],
	"91583": [
		"default",
		"./app",
		8960
	],
	"96390": [
		"default",
		"./app",
		6860
	],
	"97904": [
		"default",
		"./app",
		46116
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}